import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import { email } from '../Common/Validation';
import css from './bfm.css';

let ShareAccessForm = (props) => {
  const { handleSubmit, pristine, onClose, renderTextField } = props;
  const { adding, added, error } = props.bankfeeds;

  let buttonInfo ='Share';
  if (adding) buttonInfo = <CircularProgress size={24} />;
  if (added) buttonInfo = <CheckIcon size={24} />;

  return (
    <form className={css.wrapper} onSubmit={handleSubmit}>
      <DialogContent>
        <DialogContentText>
          Enter the client's details to Share the Bank feed management Access.
        </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Field 
                component={renderTextField}
                name="firstName"
                placeholder=" First Name"
                fullWidth 
                autoFocus />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field 
                component={renderTextField}
                name="lastName" 
                placeholder=" Last Name"
                fullWidth />
            </Grid>
            <Grid item xs={12} md={12}>
              <Field 
                component={renderTextField}
                margin="dense"
                name="emailAddress"
                placeholder=" Email Address"
                fullWidth
                validate={email} />
                <div className={css.red}>{error}</div>
              </Grid>
          </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={pristine || adding || added} 
          variant="contained" 
          color="primary">
          {buttonInfo}
        </Button>
      </DialogActions>
    </form>
  )
}

function mapStateToProps(state) {
  const { bankfeeds } = state;
  return { bankfeeds };
}

export default ShareAccessForm = connect(
  mapStateToProps
)(
  reduxForm({
    form: 'shareAccessForm',
  })(ShareAccessForm)
);


// WEBPACK FOOTER //
// ./src/components/FeedManagment/ShareAccessForm.js